import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 15.7,
			y1: 6,
			x2: 20.1,
			y2: 8.5,
			stroke: "#00f5a0",
			strokeWidth: 1,
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 21.8,
			y1: 11.5,
			x2: 21.8,
			y2: 16.5,
			stroke: "#00f5a0",
			strokeWidth: 1,
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 20.1,
			y1: 19.5,
			x2: 15.7,
			y2: 22,
			stroke: "#00f5a0",
			strokeWidth: 1,
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12.3,
			y1: 22,
			x2: 7.9,
			y2: 19.5,
			stroke: "#00f5a0",
			strokeWidth: 1,
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 6.2,
			y1: 16.5,
			x2: 6.2,
			y2: 11.5,
			stroke: "#00f5a0",
			strokeWidth: 1,
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 7.9,
			y1: 8.5,
			x2: 12.3,
			y2: 6,
			stroke: "#00f5a0",
			strokeWidth: 1,
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 5,
			r: 2,
			stroke: "#00f5a0",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 21.8,
			cy: 9.5,
			r: 2,
			stroke: "#00f5a0",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 21.8,
			cy: 18.5,
			r: 2,
			stroke: "#00f5a0",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 23,
			r: 2,
			stroke: "#00f5a0",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.2,
			cy: 18.5,
			r: 2,
			stroke: "#00f5a0",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.2,
			cy: 9.5,
			r: 2,
			stroke: "#00f5a0",
			strokeWidth: 1.5
		})
	]
});
export default SvgLogo;
